// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__37JvX","alertIcon":"ConfirmModal_alertIcon__eiyta"};